import Model from '@/models/Model.js';

export default class SlideDeckActivity extends Model {
    static entity = 'slide_deck_activities';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            slide_deck_id: this.attr(null),
            content: this.attr(null),
            acknowledgment_message: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('slide_deck_activity_templates', 'content_template_id'),
            slide_deck: this.belongsTo('slide_decks', 'slide_deck_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
